import { Box } from '@domain-group/suit-theme'

import AdCopyReviewItem from './AdCopyReviewItem'
import useAdCopyReviewer from './hooks/useAdCopyReviewer'

interface AdCopyProps {
  campaignId: number,
  sharedAdCopyTypes: string[],
}

const AdCopy = (props: AdCopyProps) => {
  const { sharedAdCopyTypes, campaignId } = props

  const adCopyReviewerPayload = useAdCopyReviewer({ campaignId, sharedAdCopyTypes })
  const { displayAdCopyTypes, filteredAdCopiesWithContent, loading } = adCopyReviewerPayload

  return (
    <Box paddingX="large" paddingBottom="large" marginTop="large" flexDirection="column">
      {!loading && displayAdCopyTypes?.map((adCopyType, index) => {
        const { key, title } = adCopyType
        const adCopy = filteredAdCopiesWithContent?.find(a => a.copy_type === key)

        if (!adCopy){
          return null
        }

        return (
          <Box flexDirection="column">
            {index !== 0 && <hr style={{ borderTopColor: 'lineColor' }} />}

            <AdCopyReviewItem adCopy={adCopy} key={key} title={title} />
          </Box>
        )
      })}
    </Box>
  )
}

export default AdCopy
